import React from 'react';
import PatientFormTemplate from '../components/PatientFormTemplate';

export default function PatientAUDITCForm() {
    return (
        <PatientFormTemplate formTitle="Alcohol Use Disorders Identification Test (AUDIT-C)" />
    );
}
